/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} About_TitleInputs */

const en_about_title = /** @type {(inputs: About_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`About PureJSON`)
};

const ko_about_title = /** @type {(inputs: About_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`PureJSON 소개`)
};

const ja_about_title = /** @type {(inputs: About_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`PureJSONについて`)
};

/**
* | output |
* | --- |
* | "About PureJSON" |
*
* @param {About_TitleInputs} inputs
* @param {{ locale?: "en" | "ko" | "ja" }} options
* @returns {LocalizedString}
*/
export const about_title = /** @type {((inputs?: About_TitleInputs, options?: { locale?: "en" | "ko" | "ja" }) => LocalizedString) & import('../runtime.js').MessageMetadata<About_TitleInputs, { locale?: "en" | "ko" | "ja" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_about_title(inputs)
	if (locale === "ko") return ko_about_title(inputs)
	return ja_about_title(inputs)
});